import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FormatListBulleted, NoteAdd } from '@mui/icons-material';
import ChoiceCard from '../components/ChoiceCard/ChoiceCard';

const RecipeManagement = () => {
  const navigate = useNavigate();

  return (
    <Stack spacing={3} sx={{ maxWidth: 500, mx: 'auto', mt: 2 }}>
      <Typography variant="h5" textAlign="center" fontWeight={600}>
        Co chceš dělat?
      </Typography>
      <ChoiceCard
        icon={<FormatListBulleted />}
        title="Tvoje recepty"
        variant="large"
        onClick={() => navigate('/your-meals')}
      />
      <ChoiceCard icon={<NoteAdd />} title="Přidat recept" variant="large" onClick={() => navigate('/new-meal')} />
    </Stack>
  );
};

export default RecipeManagement;
